<template>
  <v-app>
    <navigation />
    <app-header />
    <v-main>
      <v-container v-if="!isLoading" fluid>
        <router-view />
      </v-container>
    </v-main>
    <app-footer />
  </v-app>
</template>

<script>
import Navigation from '@/components/main/Navigation';
import AppHeader from '@/components/main/Header';
import AppFooter from '@/components/main/Footer';

export default {
  data: () => ({
    valid: true,
    isLoading: false
  }),
  components: {
    Navigation,
    AppHeader,
    AppFooter
  },
  methods: {
    doLogin() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.$router.push({ path: 'home' });
      }
    }
  }
};
</script>
